import React, { useState, useEffect } from 'react';
import SurveyService from '../../services/survey.service';
import PropTypes from 'prop-types';

const AdminPatientSurveyResponses = ({ userId }) => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (userId) {
      loadSurveyData();
    }
  }, [userId]);

  const loadSurveyData = async () => {
    try {
      setLoading(true);
      
      // Carica le risposte dell'utente
      const userResponses = await SurveyService.getUserResponses(userId);
      console.log('Risposte ricevute:', userResponses);
      setResponses(userResponses);
      
      setError('');
    } catch (err) {
      console.error('Errore nel caricamento del questionario:', err);
      setError('Impossibile caricare le risposte al questionario');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSurvey = async () => {
    const isConfirmed = window.confirm("Sei sicuro di voler cancellare il questionario di questo paziente? Questa azione non può essere annullata.");
    
    if (isConfirmed) {
      try {
        await SurveyService.deleteUserResponses(userId);
        setResponses([]);
      } catch (error) {
        console.error('[DEBUG] Error deleting survey:', error);
        setError('Errore durante la cancellazione del questionario');
      }
    }
  };

  if (loading) {
    return <div className="mt-8 border-t pt-6">Caricamento risposte del questionario...</div>;
  }

  return (
    <div className="mt-8 border-t pt-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Questionario Iniziale</h3>
        {responses.length > 0 && (
          <button
            onClick={handleDeleteSurvey}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Cancella Questionario
          </button>
        )}
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
          {error}
        </div>
      )}

      {responses.length === 0 ? (
        <p className="text-gray-600">Il paziente non ha ancora completato il questionario iniziale.</p>
      ) : (
        <div className="space-y-6">
          {responses.map((response) => {
            const question = response.question;
            
            return (
              <div key={response.id} className="bg-gray-50 p-4 rounded-lg border">
                <h4 className="font-semibold text-lg mb-2">
                  {question?.title || 'Domanda non disponibile'}
                </h4>
                <p className="text-gray-600 mb-4">
                  {question?.description || ''}
                </p>
                
                {/* Risposta testuale */}
                {response.text_answer && (
                  <div className="bg-white p-3 rounded border mb-3">
                    <p className="text-sm text-gray-500 mb-1">Risposta:</p>
                    <p>{response.text_answer}</p>
                  </div>
                )}
                
                {/* Opzioni selezionate (nuovo formato) */}
                {response.selected_options && response.selected_options.length > 0 && (
                  <div className="bg-white p-3 rounded border">
                    <p className="text-sm text-gray-500 mb-1">
                      {response.selected_options.length > 1 ? 'Opzioni selezionate:' : 'Opzione selezionata:'}
                    </p>
                    <ul className="list-disc list-inside">
                      {response.selected_options.map(selOpt => (
                        <li key={selOpt.id}>
                          {selOpt.option?.description || 'Opzione non disponibile'}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

AdminPatientSurveyResponses.propTypes = {
  userId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};

export default AdminPatientSurveyResponses;